"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureLocale = void 0;
const constants_1 = require("./constants");
const forgeSupportedLocaleCodesSet = new Set(constants_1.FORGE_SUPPORTED_LOCALE_CODES);
const localeFallbacks = {
    'en-UK': 'en-GB',
    'nb-NO': 'no-NO'
};
const ensureLocale = (rawLocale) => {
    const locale = rawLocale.replace('_', '-');
    if (forgeSupportedLocaleCodesSet.has(locale)) {
        return locale;
    }
    return localeFallbacks[locale] ?? null;
};
exports.ensureLocale = ensureLocale;
